import React from 'react';
import { Box, Checkbox, Heading, Text } from '@razorpay/blade/components';
import { useFormWithProvider } from 'forms';

import { LEAVE_POLICY_COPY } from 'components/Settings/AttendanceAndLeavesSettings/constants';
import type { AttendanceSettingsFormState } from 'components/Settings/AttendanceAndLeavesSettings/types';

type PolicyKey = keyof typeof LEAVE_POLICY_COPY;

export const LeavePolicies = () => {
  const { formData, setFieldValue } = useFormWithProvider<AttendanceSettingsFormState>();

  const policies: { key: PolicyKey; formField: keyof AttendanceSettingsFormState; visible: boolean }[] = [
    { key: 'allowHalfdays', formField: 'allowHalfdays', visible: true },
    { key: 'compulsoryLeaveRemarks', formField: 'compulsoryLeaveRemarks', visible: true },
    { key: 'allowNegativeLeaves', formField: 'allowNegativeLeaves', visible: true },
    {
      key: 'autoAttendanceLop',
      formField: 'autoAttendanceLop',
      visible: !!formData.autoAttendanceLopSettingVisible,
    },
  ];

  return (
    <Box
      padding="spacing.6"
      borderRadius="medium"
      borderWidth="thin"
      borderColor="surface.border.gray.subtle"
      backgroundColor="surface.background.gray.intense">
      <Heading size="medium">Leave policies</Heading>
      <Text marginTop="spacing.2" size="medium" color="surface.text.gray.muted">
        Rules that apply across all leave types.
      </Text>

      <Box marginTop="spacing.6" display="flex" flexDirection="column" gap="spacing.5">
        {policies
          .filter((p) => p.visible)
          .map(({ key, formField }) => {
            const copy = LEAVE_POLICY_COPY[key];
            return (
              <Checkbox
                key={key}
                isChecked={formData[formField] as boolean}
                onChange={({ isChecked }) => setFieldValue(formField, isChecked as any)}
                helpText={copy.description}>
                {copy.title}
              </Checkbox>
            );
          })}
      </Box>
    </Box>
  );
};
